import IconButton from "./IconButton";
import { useAppSelector } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";
import { EVENTS } from "../../commander/Types";
import { dispatchEvent } from "../../utils";

const HomeButton: React.FC<{}> = () => {
  const lobby = useAppSelector((state) => state.details.lobby);
  const { available, disabled } = useAppSelector(
    selectButton.bind(null, "home")
  );
  const onClick = () => dispatchEvent(EVENTS.HOME_BUTTON_PRESSED, lobby);

  return (
    <IconButton
      available={!!lobby && available}
      onClick={onClick}
      disabled={disabled}
      name="home"
      type="Home"
      soundEffect="button-click"
    />
  );
};

export default HomeButton;
